import { FC } from 'react';
import {
  HeroConversationMessage,
  Product,
  ProductMessageData,
} from '@vs-online-only-app/state';
import { ProductCard, ThumbnailSize } from '@vs-online-only-app/ui';
import ParticipantMessage from './ParticipantMessage';

type Props = {
  message: HeroConversationMessage;
};

const ProductMessage: FC<Props> = ({ message }) => {
  const messageData = message.attributes.data as ProductMessageData;
  const product: Product = {
    sku: messageData.skuCode,
    thumbnail: messageData.image,
    price: messageData.originalPrice,
    salePrice: messageData.price,
    title: messageData.title,
    currency: messageData.currency,
    url: messageData.url,
    retailer: messageData.retailer,
  };

  return (
    <ParticipantMessage message={message}>
      <ProductCard
        long
        noBorder
        noPadding
        product={product}
        thumbnailSize={ThumbnailSize.Small}
      />
    </ParticipantMessage>
  );
};

export default ProductMessage;
